import React, { useEffect, useRef, useState } from 'react'
import PNNVBar from './PNNVBar.component'
import { IPNNVState } from './store/pnnv.types'
import { useDispatch, useSelector } from 'react-redux'
import { getPNNVStateSelector } from './selectors'
import { IonButton, IonButtons, IonToolbar } from '@ionic/react'
import { Keyboard } from '@capacitor/keyboard'
import './PNNVNativeKeyboardWrapper.component.css'
import { useTranslation } from 'react-i18next'
import { setFreeTextFieldPNNVIsOpen, setFreeTextFieldPNNVCustomEvent } from './store/pnnv.actions'
import { isPlatformWeb } from '../../utilities'

const PNNVNativeKeyboardWrapper: React.FC = () => {
  const [keyboardVisible, setKeyboardVisible] = useState<boolean>(false)
  const dispatch = useDispatch()
  const pnnvState: IPNNVState = useSelector(getPNNVStateSelector)
  const { freeTextField } = pnnvState
  const { t } = useTranslation()
  const hiddenButtonRef = useRef<HTMLIonButtonElement>(null)

  useEffect(() => {
    let showHandler: any
    let hideHandler: any
    if (!isPlatformWeb()) {
      showHandler = Keyboard.addListener('keyboardWillShow', () => {
        setKeyboardVisible(true)
      })

      hideHandler = Keyboard.addListener('keyboardWillHide', () => {
        setKeyboardVisible(false)
      })
    }

    return () => {
      showHandler && showHandler.remove()
      hideHandler && hideHandler.remove()
    }
  }, [])

  return (
    <>
      <IonButton
        fill='clear'
        className='pnnv-bar-keyboard-wrapper hidden-for-PNNV-option'
        ref={hiddenButtonRef}
        onClick={(e) => {
          if (freeTextField.options?.length) {
            dispatch(setFreeTextFieldPNNVIsOpen(true))
          }
        }}></IonButton>
      {freeTextField.options?.length && !freeTextField.isOpen && keyboardVisible ? (
        <IonToolbar className='pnnv-bar-keyboard-wrapper'>
          <IonButtons slot='start'>
            <IonButton
              color='danger'
              onClick={(e) => {
                hiddenButtonRef.current && hiddenButtonRef.current.click()
              }}>
              {t('pnnv.cannotComplete')}
            </IonButton>
          </IonButtons>
          <IonButtons slot='end'>
            <IonButton color='primary' data-testid='doneButton'>
              {t('pnnv.done')}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      ) : null}
      <PNNVBar
        pnnvRenderedFromFreeTextField={true}
        hidePopup={() => {
          if (freeTextField.options?.length) {
            dispatch(setFreeTextFieldPNNVIsOpen(false))
            dispatch(setFreeTextFieldPNNVCustomEvent(null))
          }
        }}
      />
    </>
  )
}

export default PNNVNativeKeyboardWrapper
